import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full flex justify-between mb-10 md:mt-10" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "font-normal md:font-medium text-sm md:text-2xl leading-[20px] md:leading-[32px] text-brown w-20 md:w-[198px]" }
const _hoisted_4 = { class: "text-brown text-left" }
const _hoisted_5 = { class: "font-semibold text-xl leading-[24px] mb-4" }
const _hoisted_6 = { class: "font-normal text-base leading-[20px] mb-5" }
const _hoisted_7 = { class: "font-normal text-base leading-[20px] mb-10" }
const _hoisted_8 = { class: "font-bold" }

import { computed } from "vue";
import { TarotSituationPredictionResponse } from "@/types/calculators";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'PredictionResult',
  props: {
    result: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const cards = computed(() => [
  { key: "first-card", value: props.result.first_card },
  { key: "second-card", value: props.result.second_card },
  { key: "third-card", value: props.result.third_card },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card) => {
        return (_openBlock(), _createElementBlock("div", {
          key: card.key,
          class: "text-center"
        }, [
          _createElementVNode("img", {
            src: card.value.image_url,
            alt: card.value.name,
            class: "mb-4 h-[140px] w-20 md:h-[351px] md:w-[198px]"
          }, null, 8, _hoisted_2),
          _createElementVNode("p", _hoisted_3, _toDisplayString(card.value.name), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card) => {
        return (_openBlock(), _createElementBlock("div", {
          key: card.key
        }, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(t)(`calculators.tarot.situation-prediction.result-cards.${card.key}`, {
            name: card.value.name,
          })), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(card.value.meaning), 1),
          _createElementVNode("p", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("calculators.tarot.situation-prediction.result-cards.card-key")), 1),
            _createTextVNode(" " + _toDisplayString(card.value.key), 1)
          ])
        ]))
      }), 128))
    ])
  ], 64))
}
}

})